export var DEPLOY_DATE = new Date('2025-12-12T08:30:28+0000');
